import {type} from 'arktype';

export const verificationMethods: {type: VerificationMethodType; label: string}[] = [
    {type: 'telegram', label: 'Telegram'},
    {type: 'whatsapp', label: 'WhatsApp'},
    {type: 'sms', label: 'SMS'},
];

export const VerificationMethodType = type('"sms" | "whatsapp" | "telegram"');
export type VerificationMethodType = typeof VerificationMethodType.infer;
